import { RadioGroup, Text } from '@sparemin/blockhead';
import { useExportTranscriptModalContext } from '../ExportTranscriptModalContext';
import * as S from './styles';

export interface SpeakerFormatProps {}

const SpeakerFormat: React.FC<SpeakerFormatProps> = () => {
  const {
    downloadFormatting: { speakerFormat },
    onDownloadFormattingChange,
  } = useExportTranscriptModalContext();

  return (
    <S.FormatContainer>
      <Text variant="label" weight={700}>
        Format of the speaker
      </Text>

      <RadioGroup
        value={speakerFormat}
        onChange={(value) => onDownloadFormattingChange('speakerFormat', value)}
      >
        <RadioGroup.Option value="plain">
          Plain format <S.Tag>SPEAKER A</S.Tag>
        </RadioGroup.Option>

        <RadioGroup.Option value="youtube">
          YouTube format <S.Tag>{'>>'} SPEAKER A</S.Tag>
        </RadioGroup.Option>

        <RadioGroup.Option value="vttVoiceTag">
          v tag format <S.Tag>{'<v SPEAKER A>'}</S.Tag>
        </RadioGroup.Option>
      </RadioGroup>
    </S.FormatContainer>
  );
};

export default SpeakerFormat;
